// extracted by css-extract-rspack-plugin
var _1 = "CWye3oZWwoUv60OO";
var _2 = "k3VUxTrBzwM7TEqH";
var _3 = "_3HbgepiIsIeImgJ";
var _4 = "OtbP7y5XNcQparI_";
var _5 = "WLGui6pX4syNBm4f";
var _6 = "D7Y3ANUCeosNRWOV";
var _7 = "u1ynAk2v6w1WcOHk";
export { _1 as "card", _2 as "header", _3 as "minute", _4 as "player", _5 as "slider", _6 as "team", _7 as "title" }
